import { BB_NAVIGATE_HOME } from '../constants/webViewNavigateHome'
import { postHostPayload } from './reactNativeWebView'

/** Ask RN/iframe host to navigate to native Calendar (see useWebViewNavigateHomeMessage). */
export function postWebViewNavigateHomeMessage(): boolean {
  return postHostPayload({ type: BB_NAVIGATE_HOME })
}

/**
 * Sends the current view to Home via the RN host, otherwise `/` in the browser.
 * Returns true when the host accepted the message.
 */
export function navigateHomeOrNotifyHost(): boolean {
  if (postWebViewNavigateHomeMessage()) {
    return true
  }

  if ((window as any).routerHistory) {
    ;(window as any).routerHistory.push('/')
    return false
  }

  window.location.href = '/'
  return false
}
